import { useEffect } from "react";

const DEFAULT_TITLE = "Qease - Simplified Mailbox Solution";
const DEFAULT_FAVICON = `${process.env.PUBLIC_URL || ""}/favicon.ico`;

function resolveAssetUrl(path) {
    if (!path || typeof path !== "string") return null;
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    const base = (process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api").replace(
        /\/api\/?$/,
        "",
    );
    if (path.startsWith("/")) return `${base}${path}`;
    return `${base}/${path}`;
}

/**
 * Sets document title + favicon for tenant pages; restores defaults on unmount.
 */
export function useClinicDocumentMeta({ title, faviconUrl, enabled = true }) {
    useEffect(() => {
        if (!enabled) return undefined;

        const prevTitle = document.title;
        const link =
            document.querySelector('link[rel="icon"]') ||
            (() => {
                const l = document.createElement("link");
                l.rel = "icon";
                document.head.appendChild(l);
                return l;
            })();
        const prevHref = link.getAttribute("href");

        if (title) document.title = title;
        const resolved = resolveAssetUrl(faviconUrl);
        if (resolved) link.setAttribute("href", resolved);

        return () => {
            document.title = prevTitle && prevTitle.trim() ? prevTitle : DEFAULT_TITLE;
            if (prevHref) link.setAttribute("href", prevHref);
            else link.setAttribute("href", DEFAULT_FAVICON);
        };
    }, [title, faviconUrl, enabled]);
}
